import React from "react";
import styled from 'styled-components';
import { bool, func, string, number, object } from 'prop-types';
import { PRIMARY_COLOR } from "../../color-constants";

const Btn = styled.button`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${props => props.width || 40}px;
  height: 100%;
  border: 2px dashed ${PRIMARY_COLOR};
  border: 2px dashed var(--se-secondary, ${PRIMARY_COLOR});
  box-sizing: border-box;
  cursor: pointer;
  background-color: transparent;
  outline: 0;
  vertical-align: top;

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const Plus = styled.span`
  width: 28px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  opacity: 0.64;
  font-size: 36px;
  line-height: 42px;
`;

const CenterDiv = styled.div`
  flex: 1 1 0px;
`;

const Subtitle = styled.span`
  flex: 1 1 0px;
  color: ${props => props.$color ? props.$color : 'black'};
  font-weight: bold;
`;

class AddModuleButton extends React.PureComponent {

  static propTypes = {
    disabled: bool,
    onClick: func,
    title: string,
    subTitleObj: object,
    width: number,
    id: string
  };

  handleClick(event) {
    if (this.props.disabled) {
      return false;
    }
    return this.props.onClick ? this.props.onClick(event) : false;
  }

  render() {
    return (
      <Btn
        id={this.props.id}
        width={this.props.width}
        title={this.props.title}
        disabled={this.props.disabled}
        onClick={event => this.handleClick(event)}
      >
        {this.props.subTitleObj && <CenterDiv></CenterDiv>}
        <Plus>+</Plus>
        {this.props.subTitleObj && <Subtitle $color={this.props.subTitleObj.color}>{this.props.subTitleObj.label}</Subtitle>}
      </Btn>
    );
  }
}

export default AddModuleButton;
